import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { PageLayout } from '../../../../dorian-shared/types/pageLayout/PageLayout';
import { api } from '../../../api';
import { ToolComponentProps } from '../../ToolPage/toolComponentProps';
import { PageWrapper } from '../../../ui/PageWrapper';
import { showToast } from '../../../ui/utils';
import { PromotionForm, PromotionFormValues } from '../components/PromotionForm/PromotionForm';
import { canEditPromotions, getPromotionsListUrl } from '../utils/promotionUtils';

export function NewPromotionPage(props: ToolComponentProps) {
  const {
    auth, history, toolKey, toolRole,
  } = props;
  const user = auth.getUser();
  const isEditor = canEditPromotions(toolRole);
  const [saving, setSaving] = useState(false);
  const listUrl = getPromotionsListUrl(toolKey);

  useEffect(() => {
    if (!isEditor) {
      history.replace(listUrl);
    }
  }, [history, isEditor, listUrl]);

  const pageLayout: PageLayout = {
    header: { title: 'Promotions' },
    sidebar: {
      nav: [
        {
          title: 'Back',
          action: () => history.push(listUrl),
          variant: 'secondary',
          disabled: false,
        },
      ],
    },
  };

  if (!isEditor) {
    return null;
  }

  const handleSubmit = (values: PromotionFormValues) => {
    setSaving(true);
    api.post('/v1/tools/promotions', values)
      .then((response) => {
        showToast({ textMessage: 'Promotion created', variant: 'success' });
        history.push(`${listUrl}/${response.data.promotion.id}`);
      })
      .catch((err) => {
        showToast({
          textMessage: err?.response?.data?.error || 'Failed to create promotion',
          variant: 'danger',
        });
      })
      .finally(() => setSaving(false));
  };

  return (
    <PageWrapper user={user} page={pageLayout}>
      <Card className="mt-3">
        <Card.Body>
          <Card.Title>New promotion</Card.Title>
          <PromotionForm
            requireDates
            saving={saving}
            isNewPromotion
            initialValues={{
              title: '',
              identifier: '',
              storyUuid: '',
              disabled: false,
              startTime: null,
              endTime: null,
            }}
            onSubmit={handleSubmit}
          />
        </Card.Body>
      </Card>
    </PageWrapper>
  );
}
